import api from './api';

interface UserProfile {
  name: string;
  lastName: string;
  email: string;
  country: string;
  classLevel: string;
  board: string;
  currentGrade: string;
  gradeExpectation: string;
  weakness: string;
  strength: string;
}

export const getMe = async (): Promise<UserProfile> => {
  const response = await api.get('/user/getUser');
  return response.data;
};

export const updateUser = async (userData: UserProfile): Promise<UserProfile> => {
  const response = await api.put('/user/update', userData);
  return response.data;
};